var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	36782: () => (loadSingletonVersion("default", "react", true, [4,18,2,0], () => (() => (__webpack_require__(65043))))),
	49064: () => (loadSingletonVersion("default", "react-dom", true, [4,18,2,0], () => (() => (__webpack_require__(97950))))),
	31699: () => (loadStrictVersion("default", "redux", false, [1,4,1,0], () => (__webpack_require__.e(805).then(() => (() => (__webpack_require__(50805))))))),
	47628: () => (loadSingletonVersion("default", "@azure/msal-browser", false, [4,2,30,0], () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(86722))))))),
	17893: () => (loadStrictVersion("default", "axios", false, [4,1,8,2], () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(24344))))))),
	46822: () => (loadStrictVersion("default", "@ey-xd/motif-react", false, [4,6,7,0], () => (Promise.all([__webpack_require__.e(751), __webpack_require__.e(168), __webpack_require__.e(183)]).then(() => (() => (__webpack_require__(65183))))))),
	63627: () => (loadStrictVersion("default", "dompurify", false, [1,3,0,6], () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(87977))))))),
	64627: () => (loadSingletonVersion("default", "react-redux", false, [1,7,2,4], () => (__webpack_require__.e(508).then(() => (() => (__webpack_require__(97508))))))),
	70647: () => (loadSingletonVersion("default", "@azure/msal-react", false, [4,1,4,9], () => (__webpack_require__.e(564).then(() => (() => (__webpack_require__(97564))))))),
	77524: () => (loadSingletonVersion("default", "react-router-dom", true, [1,6,8,1], () => (() => (__webpack_require__(53245))))),
	96631: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [1,1,5,1], () => (__webpack_require__.e(621).then(() => (() => (__webpack_require__(92621))))))),
	97953: () => (loadStrictVersion("default", "redux-saga", false, [1,1,1,3], () => (__webpack_require__.e(642).then(() => (() => (__webpack_require__(61261))))))),
	99314: () => (loadStrictVersion("default", "moment", false, [1,2,29,4], () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))))),
	99848: () => (loadStrictVersion("default", "react-pdf", false, [4,9,0,0], () => (Promise.all([__webpack_require__.e(787), __webpack_require__.e(897)]).then(() => (() => (__webpack_require__(31787))))))),
	3548: () => (loadStrictVersion("default", "datamaps", false, [2,0,5,9], () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(16784))))))),
	32493: () => (loadStrictVersion("default", "recharts", false, [1,2,5,0], () => (Promise.all([__webpack_require__.e(751), __webpack_require__.e(838), __webpack_require__.e(677)]).then(() => (() => (__webpack_require__(25838))))))),
	37137: () => (loadStrictVersion("default", "react-idle-timer", false, [1,5,7,2], () => (__webpack_require__.e(343).then(() => (() => (__webpack_require__(67724))))))),
	40532: () => (loadStrictVersion("default", "react-d3-speedometer", false, [1,1,1,0], () => (Promise.all([__webpack_require__.e(652), __webpack_require__.e(677)]).then(() => (() => (__webpack_require__(87652))))))),
	51895: () => (loadStrictVersion("default", "ag-charts-react", false, [1,8,1,0], () => (Promise.all([__webpack_require__.e(94), __webpack_require__.e(360)]).then(() => (() => (__webpack_require__(28979))))))),
	13094: () => (loadStrictVersion("default", "ag-charts-community", false, [1,8,1,0], () => (__webpack_require__.e(671).then(() => (() => (__webpack_require__(72671))))))),
	96677: () => (loadStrictVersion("default", "d3-color", false, [4,3,1,0], () => (__webpack_require__.e(884).then(() => (() => (__webpack_require__(34884))))))),
	49897: () => (loadStrictVersion("default", "pdfjs-dist", false, [4,4,3,136], () => (__webpack_require__.e(355).then(() => (() => (__webpack_require__(79355))))))),
	32699: () => (loadStrictVersion("default", "web-vitals", false, [1,2,1,4], () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(46453)))))))
};
var initialConsumes = [36782,49064];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"33": [
		17893,
		46822,
		63627,
		64627,
		70647,
		77524,
		96631,
		97953,
		99314,
		99848
	],
	"80": [
		32699
	],
	"94": [
		13094
	],
	"294": [
		3548,
		32493,
		37137,
		40532,
		51895
	],
	"628": [
		47628
	],
	"677": [
		96677
	],
	"699": [
		31699
	],
	"792": [
		36782,
		49064
	],
	"897": [
		49897
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}